import { CategoryType } from './Interface';
import { MilestoneInitialState,milestoneError } from './Interface';
import { MilestoneTypeAction, milestoneTypes } from './Types';
const initialState: MilestoneInitialState = {
	isLoading: false,
	error: ''
};

export const milestoneReducer = (state = initialState, action: MilestoneTypeAction) => {
	switch (action.type) {
		case milestoneTypes.LOAD_CATEGORY:
			return { ...state, isLoading: true, welcome: action.payload.data , milestoneItem: undefined, error:undefined};
		case milestoneTypes.LOAD_MILESTONE_BY_CATEGORY:
			return { ...state, isLoading: true, milestone: action.payload.data , error:undefined };
		case milestoneTypes.LOAD_MILESTONE_DETAILS:
			return { ...state, isLoading: true, milestoneItem: action.payload.data,milestone:undefined, welcome: undefined , error:undefined };
		case milestoneTypes.SAVE_MILESTONE:
			return { ...state, isLoading: true , error:undefined };
		case milestoneTypes.LOAD_AGE_GROUP:
			return {...state,ageGroup:action.payload.data }
		case milestoneTypes.LOAD_MILESTONE_FAIL:
			return { ...state, error: action.payload.errors };
		case milestoneTypes.LOAD_MILESTONE_ERROR:
			return { ...state};
		default:
			return state;
	}
};
